import p5 from 'p5';
import { IonPainter } from './IonPainter';
import { Wall } from './Wall';

export class Ray {
  private _p5: IonPainter;
  private _position: p5.Vector;
  private _direction: p5.Vector;
  private _sightQuality: number;

  constructor (P5: IonPainter, position: p5.Vector, angle: number, quality: number) {
    this._p5 = P5;
    this._position = position;
    this._direction = p5.Vector.fromAngle(angle);
    this._sightQuality = quality;
  }

  public get quality (): number {
    return this._sightQuality;
  }

  public get direction (): p5.Vector {
    return this._direction;
  }

  public set direction (vector: p5.Vector) {
    this._direction = vector;
  }

  public intersects (boundry: Wall): p5.Vector {
    const x1 = boundry.a.x;
    const y1 = boundry.a.y;
    const x2 = boundry.b.x;
    const y2 = boundry.b.y;

    const x3 = this._position.x;
    const y3 = this._position.y;
    const x4 = this._position.x + this._direction.x;
    const y4 = this._position.y + this._direction.y;

    const den = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

    if (!den) {
      return;
    }

    const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / den;
    const u = - ((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / den;

    if (t > 0 && t < 1 && u > 0) {
      const intersect = this._p5.createVector();
      intersect.x = x1 + t * (x2 - x1);
      intersect.y = y1 + t * (y2 - y1);
      return intersect;
    }
    return;
  }

  public show (): void {
    this._p5.stroke(255);
    this._p5.push();
    this._p5.translate(this._position.x, this._position.y);
    this._p5.line(0, 0, this._direction.x * 10, this._direction.y * 10);
    this._p5.pop();
  }
}
